export default {
  "b2b.zadosti.all": "Vše"
};
